<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><path fill="none" d="M42,23.999V12H6 c-2.209,0-4-1.791-4-4v30c0,3.314,2.686,6,6,6h34V32" :stroke="fill"></path> <path fill="none" d="M34,7V4H6 C3.791,4,2,5.791,2,8v0c0,2.209,1.791,4,4,4" :stroke="fill"></path> <path fill="none" d="M46,32h-9 c-2.209,0-4-1.791-4-4l0,0c0-2.209,1.791-4,4-4h9V32z"></path></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>